import { useRef, useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import axios from "../../api/axiosClient";
import {
  Box,
  Button,
  Divider,
  Grid,
  Typography,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
} from "@mui/material";
import PageHeader from "../../components/ui/PageHeader";
import CustomInput from "../../components/ui/CustomInput";
import ForwardIcon from "@mui/icons-material/Forward";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";

import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import CustomTable from "../../components/ui/CustomTable";
import { useIntl } from "react-intl";
import { useLoading } from "../../components/LoadingContext";
import BasketCreationModal from "../../components/Modals/BasketCreationModal";
import CustomTablePagingInfo from "../../components/ui/CustomTablePagingInfo";
import { handleError } from "../../services/serviceBase";
import moment from "moment";
import * as apiService from "../../services/apiService";
import BasketDetailsModal from "../../components/Modals/BasketDetailsModal";

const BasketSearch = (props) => {
  const intl = useIntl();
  const idCompany = useSelector((state) => state.common.company);
  const { setLoading } = useLoading();
  const [tableHeigth, setTableHeigth] = useState(400);
  const [totalCount, setTotalCount] = useState(0);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  const [idBasket, setIdBasket] = useState(false);
  const [isBasketConfirmed, setIsBasketConfirmed] = useState(false);

  const [destination, setDestination] = useState("");
  const [destinations, setDestinations] = useState([]);
  const [sender, setSender] = useState({ text: "", value: null });
  const [senders, setSenders] = useState([]);
  const [isTriangulation, setIsTriangulation] = useState(false);

  const page = useRef(0);
  const maxPage = useRef(0);
  const rowsForPage = 20;

  const [openBasketCreationModal, setOpenBasketCreationModal] = useState(false);
  const handleOpenBasketCreationModal = () => setOpenBasketCreationModal(true);
  const handleCloseBasketCreationModal = (value) => {
    setOpenBasketCreationModal(false);
    if (value) {
      setIdBasket(value);
      handleSearchBasket();
    }
  };

  const [openBasketDetailsModal, setOpenBasketDetailsModal] = useState(false);
  const [selectedBasketId, setSelectedBasketId] = useState(null);

  const handleOpenBasketDetailsModal = (id) => {
    setSelectedBasketId(id);
    setOpenBasketDetailsModal(true);
  };

  const handleCloseBasketDetailsModal = (value) => {
    setOpenBasketDetailsModal(false);
    setSelectedBasketId(null);
  };

  const handleReset = () => {
    setRows([]);
    setSender(null);
    setDestination("");
    setIsTriangulation(false);
    setIsBasketConfirmed(false);
    setIdBasket('');
  };

  useEffect(() => {
    handleReset();
    getColumns();
    getSenders();
  }, [idCompany]);

  useEffect(() => {
    if (sender?.value) {
      getDestinations();
    }
  }, [sender, isTriangulation]);

  const getSenders = async () => {
    setLoading(true);
    var url = "/s2s/baskets/senders";
    const params = new URLSearchParams([]);
    params.append("idCompany", idCompany);
    params.append("jdaLocation", sender);

    axios
      .get(url, { params })
      .then((response) => {
        setLoading(false);
        var items = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            items.push({
              value: x.jdaLocation,
              text: `${x.jdaLocation} - ${x.description}`,
            });
          });
        }
        setSenders(items);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getDestinations = async () => {
    setLoading(true);
    var url = "/s2s/baskets/destinations";
    const params = new URLSearchParams([]);
    params.append("idCompany", idCompany);
    params.append("senderJDALocation", sender.value);
    params.append("isTriang", isTriangulation);

    axios
      .get(url, { params })
      .then((response) => {
        setLoading(false);
        var items = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            items.push({
              value: x.jdaLocation,
              text: `${x.jdaLocation} - ${x.description}`,
            });
          });
        }
        setDestinations(items);
      })
      .catch((error) => {
        setLoading(false);
        if (error?.response?.data?.type == "GenericError") {
          toast.error(
            intl.formatMessage({ id: "Error.ErrorInBasketCreation" }),
          );
        } else {
          handleError(error, intl);
        }
      });
  };

  const handleNextPage = () => {
    if (page.current < maxPage.current) {
      page.current = page.current + 1;
      handleSearchBasket();
    }
  };

  const handlePreviousPage = () => {
    if (page.current > 1) {
      page.current = page.current - 1;
      handleSearchBasket();
    }
  };

  const handleSearchBasket = async () => {
    setLoading(true);

    var url = "/s2s/baskets/search";
    const params = new URLSearchParams([]);
    params.append("IdCompany", idCompany);

    if (sender?.value) {
      params.append("JDALocationSender", sender.value);
    }

    if (destination != null && destination.length > 0) {
      params.append("JDALocationDestination", destination);
    }

    if (idBasket != null && idBasket.length > 0) {
      params.append("IdBasket", idBasket);
    }

    if (isTriangulation != null) {
       params.append("IsTriangulation", isTriangulation);
    }

    if (isBasketConfirmed != null) {
      params.append("IsBasketConfirmed", isBasketConfirmed);
    }

    if (page.current === 0) {
      page.current = 1;
    }
    params.append("PagingInfo.Skip", `${rowsForPage * (page.current - 1)}`);
    params.append("PagingInfo.Take", `${rowsForPage}`);

    axios
      .get(url, { params })
      .then((response) => {
        setLoading(false);
        setRows(response.data.paginatedItems);
        setTotalCount(response.data.totalCount);
        maxPage.current = Math.ceil(response.data.totalCount / rowsForPage);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getColumns = () => {
    setColumns([
      {
        field: "actionsDetails",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "BasketCreation.Details" })}
          </Typography>
        ),
        resizable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip title="See details">
                <IconButton
                  onClick={() => handleOpenBasketDetailsModal(params.id)}
                  size="large"
                  color="primary"
                >
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
      {
        field: "dossierKey",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Dossier key</Typography>
        ),
        flex: 1,
        minWidth: 220,
        maxWidth: 220,
      },
      {
        field: "jdaSender",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "BasketCreation.Sender" })}
          </Typography>
        ),
        flex: 1.5,
      },
      {
        field: "jdaDestination",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "BasketCreation.Destination" })}
          </Typography>
        ),
        flex: 1.5,
      },
      {
        field: "salePriceType",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "BasketCreation.SalePriceType" })}
          </Typography>
        ),
        flex: 0.5,
        minWidth: 80,
        maxWidth: 80,
      },
      {
        field: "batchNumber",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Batch number</Typography>
        ),
        flex: 1,
        minWidth: 120,
        maxWidth: 120,
      },
      {
        field: "ictNumber",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>ICT</Typography>
        ),
        flex: 1,
        minWidth: 100,
        maxWidth: 100,
      },
      {
        field: "invoiceNumber",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Invoice</Typography>
        ),
        flex: 1,
        minWidth: 130,
        maxWidth: 130,
      },
      {
        field: "idBasket",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>ID Basket</Typography>
        ),
        flex: 1,
        minWidth: 100,
        maxWidth: 100,
      },

      {
        field: "confirmedDate",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "BasketCreation.ConfirmedDate" })}
          </Typography>
        ),
        renderCell: (params) => {
          return params.row.confirmedDate != null
            ? moment(params.row.confirmedDate).format("DD-MM-YYYY")
            : null;
        },
        flex: 1,
        minWidth: 150,
        maxWidth: 150,
      },
      {
        field: "actions",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Action" })}
          </Typography>
        ),
        resizable: false,
        renderCell: (params) => {
          return (
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              {params.row.confirmedDate == null ||
              params.row.basketStep === "Error" ? (
                <Tooltip title="Push basket">
                  <IconButton
                    onClick={() => handleBasketConfirm(params.id)}
                    size="small"
                    color="primary"
                  >
                    <ForwardIcon />
                  </IconButton>
                </Tooltip>
              ) : null}

              {(params.row.confirmedDate == null ||
                params.row.basketStep === "Error") && (
                <Tooltip title="Delete basket">
                  <IconButton
                    onClick={() => handleBasketDelete(params.id)}
                    size="small"
                    color="primary"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              )}

              <Tooltip title="Copy basket">
                <IconButton
                  onClick={() => handleBasketCopy(params.id)}
                  size="small"
                  color="primary"
                >
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      },
    ]);
  };

  const handleBasketConfirm = (idS2SBasket) => {
    debugger;
    setLoading(true);
    axios
      .post(`s2s/baskets/${idS2SBasket}/finalize`)
      .then((response) => {
        setLoading(false);
        setIdBasket(idS2SBasket);
        toast.success("Basket confirmed");
        handleSearchBasket();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleBasketCopy = (id) => {
    if (!window.confirm("Confirm copy?")) {
      return false;
    }

    setLoading(true);
    let request = {
      IdCompany: idCompany,
      IdBasket: id,
    };

    var url = `/s2s/baskets/${id}/copy`;
    axios
      .post(url, request)
      .then((response) => {
        setLoading(false);
        setIdBasket(response.data);
        toast.success("Basket created!");
        handleSearchBasket();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleBasketDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this basket? This action cannot be undone.")) {
      return false;
    }

    setLoading(true);
    var url = `/s2s/baskets/${id}`;
    axios
      .delete(url)
      .then((response) => {
        setLoading(false);
        toast.success("Basket deleted successfully!");
        handleSearchBasket();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  return (
    <Box sx={{ overflow: "hidden" }}>
      <PageHeader title={intl.formatMessage({ id: "BasketCreation.Title" })} />
      <Grid container sx={{ mt: 2 }}>
        <Grid item md={3}>
          <Button
            variant="contained"
            sx={{ width: "100%" }}
            className="apeLigthBlueBackground"
            onClick={(e) => {
              handleOpenBasketCreationModal(e, props.idReturnFileHead);
            }}
          >
            {intl.formatMessage({ id: "BasketCreation.Create" })}
          </Button>
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      <Grid container>
        <Grid item md={12}>
          <form id="form">
            <Grid container mt={2}>
              <Grid item lg={5} sm={12}>
                <CustomInput
                  color="blue"
                  labelText={intl.formatMessage({
                    id: "BasketCreation.Sender",
                  })}
                  type="autocomplete"
                  textCol={3}
                  inputCol={8}
                  value={sender}
                  selectItems={senders}
                  setValue={setSender}
                />
              </Grid>
              <Grid item lg={2} sm={12}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={isTriangulation} />}
                      label={
                        <Typography sx={{ fontSize: 14 }}>
                          {intl.formatMessage({
                            id: "BasketCreation.IsTriangulation",
                          })}
                        </Typography>
                      }
                      onChange={(e) => {
                        setIsTriangulation(e.target.checked);
                      }}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item lg={5} sm={12}>
                <CustomInput
                  color="blue"
                  labelText={intl.formatMessage({
                    id: "BasketCreation.Destination",
                  })}
                  type="autocomplete"
                  textCol={4}
                  inputCol={8}
                  valueRef={destination}
                  selectItems={destinations}
                  setValue={setDestination}
                  //selectFirst={true}
                />
              </Grid>
              <Grid item lg={5}>
                <CustomInput
                  labelText="ID Basket"
                  type="text"
                  value={idBasket}
                  setValue={setIdBasket}
                  textCol={3}
                  inputCol={8}
                />
              </Grid>
              <Grid item lg={6}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={isBasketConfirmed} />}
                      label={
                        <Typography sx={{ fontSize: 14 }}>
                          {intl.formatMessage({
                            id: "BasketCreation.IsBasketConfirmed",
                          })}
                        </Typography>
                      }
                      onChange={(e) => {
                        setIsBasketConfirmed(e.target.checked);
                      }}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item lg={10}></Grid>
              <Grid item lg={2} mt={2}>
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleSearchBasket}
                >
                  {intl.formatMessage({ id: "General.Search" })}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
      <Grid mt={2}>
        <CustomTablePagingInfo
          totalCount={totalCount}
          page={page.current}
          maxPage={maxPage.current}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
        />
        <CustomTable
          columns={columns}
          rows={rows}
          id={"idBasket"}
          rowHeight={70}
          headerHeight={50}
          tableHeight={tableHeigth}
          getRowClassName={(params) =>
            params.row.basketStep === "Error" ? "row-error" : ""
          }
        />
      </Grid>
      <BasketCreationModal
        openModal={openBasketCreationModal}
        handleCloseModal={handleCloseBasketCreationModal}
        senders={senders}
      />
      <BasketDetailsModal
        openModal={openBasketDetailsModal}
        handleCloseModal={handleCloseBasketDetailsModal}
        basketId={selectedBasketId}
      />
    </Box>
  );
};

export default BasketSearch;
